import React, { FC } from 'react';
import { Stack } from '@mui/material';

import { ChatSquareIcon } from 'src/shared/components';

interface Props {
  notes: { label: string; value: string }[];
  direction?: 'column' | 'row';
}

export const CalendarNotesInfo: FC<Props> = ({ notes, direction = 'row' }) => {
  return (
    <Stack spacing={0.5}>
      {notes.map(({ label, value }, index) => (
        <div
          key={`event-calendar-note-${label}-${index}`}
          className={`d-flex align-items-start my-3 ${direction === 'row' ? 'flex-row' : 'flex-column'}`}
        >
          <div className="d-flex align-items-center">
            <ChatSquareIcon color="#6C757D" size={20} className="me-2" />
            <span className="fw-500 me-1">{label}:</span>
          </div>
          <span className="fw-300 fst-italic">&#34;{value}&#34;</span>
        </div>
      ))}
    </Stack>
  );
};
